import FindResourceEntryInteractor from "../../core/interactor/app/crud/FindResourceEntryInteractor";
import Constants from "../../caseLawDocuments/common/Constants";
import { IOrganisation } from "../model/Organisation";
import OrganisationMapper from "../service/OrganisationMapper";
import OrganisationParamMapper from "../service/OrgansationParamMapper";

export default class GetOrganisationInteractor {
  private resource: FindResourceEntryInteractor<IOrganisation>;

  constructor({ findResourceEntry }: any) {
    this.resource = findResourceEntry;
  }

  async execute(id: number) {
    return this.resource.execute(
      Constants.organisationsPath,
      OrganisationMapper,
      OrganisationParamMapper,
      id
    );
  }
}
